import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'

import { callApi } from '../services/fetchService'
import { loadGlobals, openPatientRecord, closePatientRecord } from '../actions'

import DataTable from '../components/DataTable'
import FaIcon from '../components/FaIcon'
import TableButton from '../components/TableButton'

import { Button, Modal, message } from 'antd'
const confirm = Modal.confirm


class Patients extends Component {

    state = {
        loading: false
    }

    static propTypes = {
        loadGlobals: PropTypes.func.isRequired,
        openPatientRecord: PropTypes.func.isRequired,
        closePatientRecord: PropTypes.func.isRequired,
        comboboxes: PropTypes.object.isRequired,
        patient: PropTypes.object,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired,
        session: PropTypes.object.isRequired,
        patients: PropTypes.array.isRequired,
        isPatientsLoading: PropTypes.bool.isRequired
    }

    delete = (patient) => {
        const { intl, loadGlobals, closePatientRecord } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'patients/' + patient.id,
            method: 'DELETE'
        }).then((data) => {
            message.success(intl.formatMessage({ id: 'misc.deleteSuccess' }))
            this.fetch()
            loadGlobals()
            this.setState({ loading: false })
            if (this.props.patient && this.props.patient.id === patient.id) {
                closePatientRecord();
            }
        }).catch((data) => {
            message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            this.setState({ loading: false })
        })
    }

    confirmDelete = (patient) => {
        const { intl } = this.props
        const self = this
        confirm({
            title: intl.formatMessage({ id: 'misc.confirm2' }),
            okText: intl.formatMessage({ id: 'misc.deleteCaps' }),
            okType: 'danger',
            content: intl.formatMessage({ id: 'patients.confirmDelete' }),
            onOk() {
                return self.delete(patient)
            },
            onCancel() { }
        })
    }

    openPatientRecord = (patient) => {
        this.props.openPatientRecord(patient)
    }

    rowsConfig = (record) => ({
        style: { cursor: 'pointer' },
        onClick: (e) => this.props.history.push('/patient/' + record.id)
    })

    render() {
        const { loading, isPatientsLoading } = this.state
        const { user } = this.props.session
        const { patients } = this.props

        const columns = [
            { title: "patients.nameColumn", dataIndex: "fullName", type: "string", sorter: true, defaultSortOrder: "ascend" },
            { title: "patients.consultationsColumn", dataIndex: "numberOfConsultations", type: "number", sorter: true },
            { title: "patients.bloodTestsColumn", dataIndex: "numberOfBloodTests", type: "number", sorter: true },
            { title: "patients.mainPathologyColumn", dataIndex: "mainPathologyName", type: "string", sorter: true },
            {
                title: "misc.actions", width: "100px", key: "action", render: (record) => (
                    <span>
                        <TableButton color="blue" icon="folder-open" onClick={this.openPatientRecord} value={record} />
                        <TableButton color="red" icon="trash-alt" onClick={this.confirmDelete} value={record} confirm />
                    </span>
                )
            }
        ]

        return (
            <div>
                <h1><FaIcon icon="users" fixedWidth /> <FormattedMessage id="patients.title" /></h1>
                <div className="action-bar"><Link to="/patient"><Button disabled={!user.canAddConsultations}><FaIcon icon="plus" /> <FormattedMessage id="patients.addPatient" /></Button></Link></div>
                <DataTable columns={columns} dataSource={patients} loading={loading || isPatientsLoading} rowKey="id" size="middle" onRow={this.rowsConfig} />
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes,
    patient: state.patient,
    session: state.session,
    patients: state.patients,
    isPatientsLoading: state.isPatientsLoading
})

export default withRouter(injectIntl(connect(mapStateToProps, {
    loadGlobals,
    openPatientRecord,
    closePatientRecord
})(Patients)))


// WEBPACK FOOTER //
// ./src/views/Patients.js